document.addEventListener("DOMContentLoaded", () => {
  var CarouselSwiper = new Swiper(".carousel-diagram-box", {
    cssMode: true,
    navigation: {
      nextEl: ".carousel-btn-next",
      prevEl: ".carousel-btn-prev",
    },
    pagination: {
      el: ".carousel-pagination",
      clickable: true,
    },
    mousewheel: true,
    keyboard: true,
    on: {
    slideChange: function() {
      const currentIndex = this.activeIndex;

      const targetBtn = Array.from(btnList).find(
        btn => Number(btn.dataset.index) - 1 === currentIndex
      );
      
      if (targetBtn) {
        setActiveButton(targetBtn);
      }
    }
  }
  });

  const btnList = document.querySelectorAll(".toggle-btn");
  
  const setActiveButton = (activeBtn) => {
    btnList.forEach((btn) => btn.classList.toggle("active", btn === activeBtn));
  };

  function toggleBtnClick() {
    const bulletList = document.querySelectorAll(".carousel-pagination .swiper-pagination-bullet");
    btnList.forEach((btn) => {
      btn.addEventListener("click", function () {
        const index = Number(this.dataset.index) - 1;
        const bullet = bulletList[index];

        if (bullet) {
          bullet.dispatchEvent(
            new MouseEvent("click", {
              bubbles: true,
              cancelable: true,
              view: window,
            })
          );

          setActiveButton(this);
        }
      });
    });
  }

  const checkInterval = setInterval(() => {
    const relatedContainer = document.querySelector(".carousel-diagram-box .swiper-pagination-bullet");
    if (relatedContainer) {
      toggleBtnClick();
      clearInterval(checkInterval);
    }
  }, 1000);
});
